const assetsUrl = (
  process.env.NEXT_PUBLIC_ASSETS_URL || 'https://assets.caterdesk-static.com'
).replace(/\/+$/, '')

export const IMAGES_URL = (
  process.env.NEXT_PUBLIC_IMAGES_URL || 'https://img.teamfeedr.com'
).replace(/\/+$/, '')

export const SOURCING_SCRIPT_URL = `${assetsUrl}/website-assets/sourcing.min.js`
